const LvNewApplicationRequestTemplate = require('../contents/LvNewApplicationRequestTemplate.json');
const LtNewApplicationRequestTemplate = require('../contents/LtNewApplicationRequestTemplate.json');
const EeNewApplicationRequestTemplate = require('../contents/EeNewApplicationRequestTemplate.json');
const EeNewLightApplicationRequestTemplate = require('../contents/EeNewLightApplicationRequestTemplate.json');

const requestTemplates = {
  LT: LtNewApplicationRequestTemplate,
  LV: LvNewApplicationRequestTemplate,
  EE: EeNewApplicationRequestTemplate,
};

function getExampleRequestData(domain, exampleRequest) {
  if (domain === 'EE' && exampleRequest === 'EeNewLightApplicationRequestTemplate') {
    return EeNewLightApplicationRequestTemplate;
  }

  return requestTemplates[domain] || null;
}

function parseParameters(parameters) {
  return parameters.map((item) => ({
    ...item,
    context: `${item.required ?? 'false'} | ${item.type} ${item.in ? `| ${item.in}` : ''}`,
  }));
}

function getDocumentationBaseUrl(domain, href) {
  const codeMap = { LT: 'lt', LV: 'lv', EE: 'ee' };
  const code = codeMap[domain];

  if (!code) {
    return '';
  }

  const buildURL = (template) => template.replace('{code}', code);
  const prodURLTemplate = domain === 'LV' ? 'https://broker.bigbank.{code}' : 'https://partner-api.bigbank.{code}';
  const devURL = buildURL('https://group-partner-api-{code}-dev.dca.origin.big.local');
  const stagingURL = buildURL('https://partner-api-test.bigbank.{code}');
  const prodURL = buildURL(prodURLTemplate);

  if (href.includes(devURL) || href.includes('localhost')) {
    return devURL;
  }
  if (href.includes(stagingURL)) {
    return stagingURL;
  }
  if (href.includes(prodURL)) {
    return prodURL;
  }

  return '';
}

module.exports = {
  getDocumentationBaseUrl,
  getExampleRequestData,
  parseParameters,
};
